import {UserResultPrefValueType} from '@sharedcommon/model/user.result-pref.model';

export class GenericResultDetailFilterModel {

  id: number;
  /**
   * If the the operating mode is feed
   * this attribute will be filled
   */
  rawMaterialId: string;
  /**
   * If the the operating mode is sample
   * this attribute will be filled
   */
  sampleId: string;
  matrixCode: string;
  valueType: string;


  constructor(
    id: number,
    rawMatOrSampleId: string,
    matrixCode: string,
    valueType: UserResultPrefValueType,
    sampleMode: boolean
  ) {
    this.id = id;
    if (sampleMode) {
      this.sampleId = rawMatOrSampleId;
    } else {
      this.rawMaterialId = rawMatOrSampleId;
    }
    this.matrixCode = matrixCode;
    switch (valueType) {
      case UserResultPrefValueType.CALCULATED:
        this.valueType = 'CALCULATED';
        break;
      case UserResultPrefValueType.SAVED:
        this.valueType = 'SAVED';
        break;
      case UserResultPrefValueType.STANDARD:
        this.valueType = 'STANDARD';
        break;
      default:
        console.error("[GenericResultDetailFilterModel] value type [", valueType, "] not handled");
    }
  }
}
